import Routes from './Routes';
import './styles/index.scss';

export default Routes;
